import { defineContent } from './defineContent.js';
import data from './support.json';
import { supportSchema } from './support.schema.js';

export const support = defineContent(supportSchema, data);
